import helper from './helper'
import axios from '@/axios'
import EventBus from '@/eventbus'

export default {
  uploadToS3(presigned, file) {
    return new Promise((resolve, reject) => {
      require('axios')
        .put(presigned.url, file, {
          onUploadProgress: function (progressEvent) {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            EventBus.$emit(file.name, percentCompleted)
          }
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getPresignedLink(bucket, file) {
    return helper.post(`/uploads/presigned-link`, { bucket, file });
  }
}
